import { render } from "./UiImageEditor.vue?vue&type=template&id=216fec72"
import script from "./UiImageEditor.vue?vue&type=script&lang=js"
export * from "./UiImageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__